<finxone-web-frontend-text
  [isUsingHtmlStructure]="pageConfig.isUsingHtmlStructure ?? true"
  [contentStyle]="contentStyle"
  [selectedTextStyleClass]="selectedTextStyleClass"
  [colorTextAlignStyle]="colorTextAlignStyle"
  [renderedContent]="renderedContent"
></finxone-web-frontend-text>
